// extracted by mini-css-extract-plugin
module.exports = {"textInput":"SvLpcFt6","isDark":"_1N8qAGhe"};